import styled from 'styled-components';

import { Headline } from 'components/Headline';

const Container = styled.div`
  grid-area: table;

  width: 50rem;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3rem;
`;

const Title = styled(Headline)`
  margin: 0;
`;

const PriceTypeSelector = styled.div`
  min-width: 18rem;
`;

export { Container, Header, PriceTypeSelector, Title };
